import { render, staticRenderFns } from "./CustomTabset.vue?vue&type=template&id=e4b4b4bc&"
import script from "./CustomTabset.vue?vue&type=script&lang=js&"
export * from "./CustomTabset.vue?vue&type=script&lang=js&"
import style0 from "./CustomTabset.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports